import { render, staticRenderFns } from "./ScholarshipAttendanceHistory.vue?vue&type=template&id=359baa11&"
import script from "./ScholarshipAttendanceHistory.vue?vue&type=script&lang=js&"
export * from "./ScholarshipAttendanceHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports